import { LinkContainer } from 'react-router-bootstrap';
import { Table, Button, Row, Col } from 'react-bootstrap';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import Paginate from '../../components/PaginateDirectorates';
import {
  useGetDirectoratesQuery,
  useDeleteDirectorateMutation,
  useCreateDirectorateMutation,
} from '../../slices/adminDirectorateApiSlice';

import { toast } from 'react-toastify';

const DirectorateListScreen = () => {
  const { pageNumber } = useParams();

  const { data, isLoading, error, refetch } = useGetDirectoratesQuery({
    pageNumber,
  });

  //console.log('Data', data);

  const [deleteDirectorate, { isLoading: loadingDelete }] =
    useDeleteDirectorateMutation();

  const deleteHandler = async (id) => {
    if (window.confirm(`Are you sure  ${id}`)) {
      try {
        await deleteDirectorate(id);
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  const [createDirectorate, { isLoading: loadingCreate }] =
    useCreateDirectorateMutation();

  const createDirectorateHandler = async () => {
    if (window.confirm('Are you sure you want to create a new Directorate?')) {
      try {
        await createDirectorate();
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  return (
    <>
      <Row className='align-items-center'>
        <Col>
          <h1>Directorate's</h1>
        </Col>
        <Col className='text-end'>
          <Button className='my-3' onClick={createDirectorateHandler}>
            <FaPlus /> Create A New Directorate
          </Button>
        </Col>
      </Row>

      {loadingCreate && <Loader />}
      {loadingDelete && <Loader />}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error.data.message}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className='table-sm'>
            <thead>
              <tr>
                <th>ID</th>
                <th>Directorate Name</th>

                <th>Active Y or N</th>

                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.directorates.map((directorate) => (
                <tr key={directorate._id}>
                  <td>{directorate._id}</td>
                  <td>{directorate.directorate}</td>

                  <td>{directorate.activeYorN}</td>

                  <td>
                    <LinkContainer
                      to={`/admin/directorate/${directorate._id}/edit`}
                    >
                      <Button variant='outline-info' className='btn-sm mx-2'>
                        <FaEdit /> Edit Item
                      </Button>
                    </LinkContainer>

                    <Button
                      variant='warning'
                      className='btn-sm'
                      onClick={() => deleteHandler(directorate._id)}
                    >
                      <FaTrash
                        className='text-end'
                        style={{ color: 'white' }}
                      />{' '}
                      Delete
                    </Button>
                  </td>

                  {/*
                  

                                    <td>
                                        <LinkContainer to={`/admin/directorate/${directorate._id}/edit`}>
                                            <Button variant='light' className='btn-sm mx-2'>
                                                <FaEdit />
                                            </Button>
                                        </LinkContainer>
                                        <Button
                                            variant='danger'
                                            className='btn-sm'
                                            onClick={() => deleteHandler(directorate._id)}
                                        >
                                            <FaTrash style={{ color: 'white' }} />
                                        </Button>
                                    </td>

                            */}
                </tr>
              ))}
            </tbody>
          </Table>
          <Paginate pages={data.pages} page={data.page} isAdmin={true} />
        </>
      )}
    </>
  );
};

export default DirectorateListScreen;
